<template>
  <div class="antialiased">
    <TooltipProvider :delay-duration="150">
      <SidebarProvider>
        <IdpSidebar />
        <SidebarInset class="min-w-0">
          <ViewAsBanner />
          <header class="sticky top-0 z-40 border-b bg-background/80 backdrop-blur-md">
            <div class="flex h-14 items-center gap-2 px-4">
              <SidebarTrigger class="-ml-1" />
              <div class="ml-auto flex items-center gap-2">
                <Button
                  variant="ghost"
                  size="icon-sm"
                  :aria-label="theme.isDark.value ? 'Switch to light mode' : 'Switch to dark mode'"
                  @click="theme.toggleTheme"
                >
                  <Sun v-if="theme.isDark.value" />
                  <Moon v-else />
                </Button>
              </div>
            </div>
          </header>
          <router-view></router-view>
        </SidebarInset>
      </SidebarProvider>
    </TooltipProvider>
  </div>
</template>

<script setup lang="ts">
import { inject, onBeforeUnmount, onMounted } from 'vue'
import { Moon, Sun } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar'
import { TooltipProvider } from '@/components/ui/tooltip'
import { useTheme } from '../../utils/useTheme'
import IdpSidebar from './IdpSidebar.vue'
import ViewAsBanner from './ViewAsBanner.vue'

const theme = inject('theme', useTheme())

// On <body>, not a wrapper: sheets, selects and tooltips portal there.
onMounted(() => document.body.classList.add('idp-theme'))
onBeforeUnmount(() => document.body.classList.remove('idp-theme'))
</script>
